import React, { useContext } from "react";
import { Dropdown, Icon, Menu, message, Modal } from "antd";
import { AnswerContent, DiscussContent } from "../../../../context";
import { deleteReply } from "../../../../../../../API/discuss";
import { errorMessage } from "../../../../../../../Utils/useRequest";

interface Props {
    editUuid: string;
}
export function AnswerMange({ editUuid }: Props) {
    const { answerData } = useContext(AnswerContent);
    const { updateDiscussDetail, setIsWriting, setEditUuid } =
        useContext(DiscussContent);

    function onDelete() {
        Modal.confirm({
            content: "你确定要删除这层楼吗？",
            onOk: async () => {
                try {
                    await deleteReply(answerData.topicUuid, answerData.uuid);
                    message.success("删除成功!");
                    updateDiscussDetail();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    function onEdit() {
        setEditUuid(editUuid);
        setIsWriting(true);
    }

    const menu = (
        <Menu style={{ width: 80, textAlign: "center" }}>
            <Menu.Item onClick={onEdit}>编辑</Menu.Item>
            <Menu.Item onClick={onDelete}>删除</Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu} placement="bottomCenter">
            <Icon type="more" />
        </Dropdown>
    );
}
